import { render, staticRenderFns } from "./FeaturePhotoEditor.vue?vue&type=template&id=3b1a6b83&"
import script from "./FeaturePhotoEditor.vue?vue&type=script&lang=js&"
export * from "./FeaturePhotoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports